import { graphql } from "@opensea/graphql"
import { readSwapImpactFragment } from "../../../provider/readSwapImpact.fragment"

export const SwapDetailsSwapImpactItemFragment = graphql(
  `
    fragment SwapDetailsSwapImpactItem on SwapRouteResult {
      ...readSwapImpact
    }
  `,
  [readSwapImpactFragment],
)
